<template>
  <div class="search-item" :style="{width:searchWidth}">
    <label class="search-label">{{searchLabel}}</label>
    <el-checkbox-group class="search-checkbox" v-model="value">
      <el-checkbox-button v-for="(item,index) in searchTermList" :label="item.id" :key="index">{{item.name}}</el-checkbox-button>
    </el-checkbox-group>
  </div>
</template>
<script>
  export default {
    name: "searchCheckbox",
    props: {
      searchLabel: {
        type: String,
        default: ''
      },
      searchWidth: {
        type: String,
        default: ''
      },
      searchValue: {
        type: Array,
        default: []
      },
      searchTermList:{
        type: Array,
        default: []
      }
    },
    data: function() {
      return {
        value: this.searchValue
      }
    },
    /* computed: {
    }, */
    methods: {
    }
  };
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/list/search/searchCheckbox.vue